module.exports = __webpack_public_path__ + "images/emoji/gun.b0f1ae2ab00be4b308c7.png";